import { PayloadAction } from '@reduxjs/toolkit';
import { IPlacementRequirementKey } from 'app/models/Placement/PlacementDetails';
import InitPlacementSummary, { IConsolidatedRequirementResponse } from '../init.types';
import { IPlacementSummaryRequest } from '../slice';
import {
  processPlacementStatusRequirements,
  requestPlacementStatusRequirements,
  type IPlacementStatusRequirementHelperConfig,
} from './statusRequirementHelper';

const startDateStatusRequirementConfig: IPlacementStatusRequirementHelperConfig = {
  consolidatedField: 'startDateStatusDetails',
  requirementKey: 'orderRequirement',
  messageTypeId: IPlacementRequirementKey.placementStartDate,
  getMessageId: req => req.messageId as number,
  requestError: {
    functionName: 'requestStartDateStatusRequirements',
    area: 'src/store/redux-store/placement-summary/common-saga/startDateStatusRequirement.ts',
  },
  processError: {
    functionName: 'processStartDateStatusRequirements',
    area: 'src/store/redux-store/placement-summary/common-saga/startDateStatusRequirement.ts',
  },
};

export function* requestStartDateStatusRequirements(action: PayloadAction<IPlacementSummaryRequest>) {
  yield* requestPlacementStatusRequirements(startDateStatusRequirementConfig);
}

export function* processStartDateStatusRequirements(
  response: IConsolidatedRequirementResponse<unknown>,
  _context: InitPlacementSummary,
) {
  yield* processPlacementStatusRequirements(response, startDateStatusRequirementConfig);
}
